import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { ToastContainer } from "react-toastify";
import { types } from "../../redux/type";
import { userActions } from "../../redux/actions";
import Button from "../../component/button/Button";
import ErrorRender from "../../component/request/ErrorRender";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import LeftNav from "../../component/leftSideNav/LeftNav";
import P from "../../component/smallComponents/P";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import TextInput from "../../component/input/TextInput";
import TopBar from "../../component/topBar/TopBar";
import { toastHelper } from "../../constant/helper/helper";

const Setting = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;
  const [errors, setErrors] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isShowPassword, setIsShowPassword] = useState(false);

  const {
    userError,
    userLoading,
    userStatus,
    userResponse
  } = useSelector((state) => state.user);

  useEffect(() => {
    setErrors(userError);
  }, [userError]);

  useEffect(() => {
    if (userResponse) {
      toastHelper("success", userResponse);
    }
  }, [userResponse]);

  useEffect(() => {
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(userActions.setUserLoading(false));

    return () => {
      dispatch(userActions.clearUserErrors());
      dispatch(userActions.clearUserResult());
      dispatch(userActions.setUserLoading(false));
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      const userInfo = {
        newPassword,
        ipAddress: localStorage?.publicIpAdd,
        deviceDetails: localStorage.browserDetails,
        latitude: localStorage.latitude,
        workerId: localStorage.workerId,
        longitude: localStorage.longitude
      };
      dispatch(userActions.setUserLoading(true));
      dispatch(userActions.clearUserErrors());
      dispatch(userActions.clearUserResult());
      dispatch(userActions.changePassword(userInfo, loginType));
    } else {
      const errorData = {
        data: {
          message: "New Password and Confirm Password Not matched"
        },
        status: 400
      };
      dispatch({
        type: types.UserTypes.USER_GET_ERRORS,
        payload: errorData
      });
    }
  };

  return (
    <div className="wrapper">
      <LeftNav />
      <ToastContainer />
      <div className="content-page">
        <TopBar title="Change Password" />
        <div className="content">
          <div className="container-fluid">
            <div className="authentication-bg">
              <div className="account-pages mt-5 mb-5">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-5">
                      <div className="card">
                        <div className="card-header pt-4 text-center bg-dark">
                          <span>
                            <img
                              src="https://i.imgur.com/ahvlkuu.png"
                              alt=""
                              height="35"
                            />
                          </span>
                        </div>
                        <div className="card-body p-4 bg-dark">
                          <div className="text-center w-75 m-auto">
                            <HeaderTag
                              type="h4"
                              title="Change Password"
                              isClassName={true}
                              className="text-white text-center mt-0 font-weight-bold"
                            />
                            <P title="Enter New Password and Confirm Password to Change Password." />
                          </div>
                          <form onSubmit={onSubmit}>
                            <TextInput
                              type={
                                isShowPassword ? "text" : "password"
                              }
                              required={true}
                              textWhite={true}
                              value={newPassword}
                              label="New Password"
                              htmlFor="newPassword"
                              placeholder="Enter New Password"
                              onChange={(e) =>
                                setNewPassword(e.target.value)
                              }
                            />
                            <TextInput
                              required={true}
                              textWhite={true}
                              htmlFor="password"
                              value={confirmPassword}
                              label="Confirm Password"
                              placeholder="Enter your password"
                              type={
                                isShowPassword ? "text" : "password"
                              }
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />

                            <div className="form-group mb-3">
                              <input
                                type="checkbox"
                                value={isShowPassword}
                                onChange={(e) =>
                                  setIsShowPassword(!isShowPassword)
                                }
                              />
                              <label className="ml-2 text-white">
                                Show Password
                              </label>
                            </div>

                            <div className="form-group mb-0 text-center mt-3">
                              {userLoading ? (
                                <SpinnerButton />
                              ) : userStatus === 1 ? null : (
                                <Button
                                  title="Change Password"
                                  icon="mdi mdi-login"
                                  type="submit"
                                  isBackgroundColor={true}
                                />
                              )}
                            </div>
                            {errors ? (
                              <ErrorRender errors={errors} />
                            ) : null}
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="text-center w-75 m-auto">
                      <P
                        title="This site is available for Authorized users. If you
                      are not authorized user, please  don't attempt to
                      change Password. All activities performed on this site are
                      logged and monitored."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <footer className="footer footer-alt">
                <p>
                  Developed and maintain by{" "}
                  <strong className="text-dark">VITORSCAPE</strong>
                </p>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
